import { ThemeConfig } from "@/config/theme/themeTypes";

const KEY_TO_CSS_VAR: Record<keyof ThemeConfig["colors"], string> = {
  primary:       "--theme-primary",
  primaryHover:  "--theme-primary-hover",
  primaryActive: "--theme-primary-active",
  secondary:     "--theme-secondary",
  background:    "--theme-background",
  surface:       "--theme-surface",
  text:          "--theme-text",
  textMuted:     "--theme-text-muted",
  border:        "--theme-border",
  success:       "--theme-success",
  warning:       "--theme-warning",
  danger:        "--theme-danger",
  info:          "--theme-info",
  onPrimary:     "--theme-on-primary",
  onSurface:     "--theme-on-surface"
};

export function createThemeCssVars(theme: ThemeConfig): Record<string, string> {
  const out: Record<string, string> = {};
  (Object.keys(KEY_TO_CSS_VAR) as Array<keyof typeof KEY_TO_CSS_VAR>).forEach(k => {
    out[KEY_TO_CSS_VAR[k]] = theme.colors[k];
  });
  out["--theme-primary-gradient"] = `linear-gradient(0deg, ${theme.colors.primary} 0%, ${theme.colors.primaryHover} 50%, ${theme.colors.primaryActive} 100%)`;

  // Derived: primary con alpha ~20% (Fase 36.13). Sirve para tints
  // sutiles tipo "highlight" / underline detrás de títulos. Antes esto
  // era hex literal #fde6c3 (naranja claro hardcoded). Hex con alpha
  // (CSS Color L4) — soporte: Chrome 62+, FF 49+, Safari 9.1+, Edge 79+.
  out["--theme-primary-tint"] = `${theme.colors.primary}33`;
  return out;
}
